// ═══════════════════════════════════════════════════════════════════════════════
// Employer Level Limits (§22)
// ═══════════════════════════════════════════════════════════════════════════════
import { TASK_KIND } from '../constants/index.js';
/** Employer membership level: L1 trial, L2 free, L3 paid. */
export const USER_LEVEL = {
    TRIAL: 1,
    FREE: 2,
    PAID: 3,
};
export const isUserLevel = (value) => value === USER_LEVEL.TRIAL || value === USER_LEVEL.FREE || value === USER_LEVEL.PAID;
/** API / client error codes for limit enforcement. */
export const LIMIT_ERROR_CODE = {
    TOTAL_TASK_LIMIT_REACHED: 'TOTAL_TASK_LIMIT_REACHED',
    COMMENT_LIMIT_REACHED: 'COMMENT_LIMIT_REACHED',
    DAILY_TASK_SUBMIT_LIMIT_REACHED: 'DAILY_TASK_SUBMIT_LIMIT_REACHED',
    DAILY_TASK_REVIEW_LIMIT_REACHED: 'DAILY_TASK_REVIEW_LIMIT_REACHED',
    DAILY_RECEIPT_LIMIT_REACHED: 'DAILY_RECEIPT_LIMIT_REACHED',
    DAILY_AI_ANALYZE_LIMIT_REACHED: 'DAILY_AI_ANALYZE_LIMIT_REACHED',
    TASK_KIND_NOT_ALLOWED: 'TASK_KIND_NOT_ALLOWED',
    AUTO_TRANSLATION_NOT_ALLOWED: 'AUTO_TRANSLATION_NOT_ALLOWED',
    INVENTORY_LOCATION_LIMIT_REACHED: 'INVENTORY_LOCATION_LIMIT_REACHED',
    INVENTORY_CATEGORY_LIMIT_REACHED: 'INVENTORY_CATEGORY_LIMIT_REACHED',
    PIN_MESSAGE_LIMIT_REACHED: 'PIN_MESSAGE_LIMIT_REACHED',
    PIN_MESSAGE_ACTIVE_LIMIT_REACHED: 'PIN_MESSAGE_ACTIVE_LIMIT_REACHED',
};
const ALL_TASK_KINDS = [
    TASK_KIND.STANDARD,
    TASK_KIND.INVENTORY,
    TASK_KIND.PICKUP_DROPOFF,
    TASK_KIND.MEDICATION_REMINDER,
];
/** Default limits per level (§22.3); runtime reads system_settings.limits_by_level. */
export const DEFAULT_LIMITS_BY_LEVEL = {
    [USER_LEVEL.TRIAL]: {
        maxTotalTasks: 10,
        maxDailyTaskSubmits: 5,
        maxDailyTaskReviews: 5,
        maxDailyReceipts: 10,
        maxDailyAiAnalyze: 20,
        maxCommentsPerTarget: 10,
        maxCommentLength: 200,
        autoTranslationEnabled: true,
        allowedTaskKinds: [...ALL_TASK_KINDS],
        maxInventoryLocations: 2,
        maxInventoryCategories: 2,
    },
    [USER_LEVEL.FREE]: {
        maxTotalTasks: 10,
        maxDailyTaskSubmits: 3,
        maxDailyTaskReviews: 3,
        maxDailyReceipts: 5,
        maxDailyAiAnalyze: 5,
        maxCommentsPerTarget: 10,
        maxCommentLength: 200,
        autoTranslationEnabled: false,
        allowedTaskKinds: [TASK_KIND.STANDARD],
        maxInventoryLocations: null,
        maxInventoryCategories: null,
    },
    [USER_LEVEL.PAID]: {
        maxTotalTasks: null,
        maxDailyTaskSubmits: 50,
        maxDailyTaskReviews: 50,
        maxDailyReceipts: 20,
        maxDailyAiAnalyze: 50,
        maxCommentsPerTarget: 10,
        maxCommentLength: 200,
        autoTranslationEnabled: true,
        allowedTaskKinds: [...ALL_TASK_KINDS],
        maxInventoryLocations: 10,
        maxInventoryCategories: 10,
    },
};
//# sourceMappingURL=employerLimits.js.map